import styled from "styled-components";

export const Container = styled.div`
  display: flex;

  width: 35vw;
  height: 65vh;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  height: 100%;

  border-radius: 0.25rem;

  align-items: center;
  justify-content: space-evenly;

  font-family: "Mulish";

  background-color: #f5f5f5;

  .header {
    display: flex;

    width: 100%;
    height: 15%;

    align-items: center;
    justify-content: center;

    font-size: 2rem;
    font-weight: bold;

    position: relative;

    border-bottom: 2px solid #dfe0eb;
  }

  .register-header {
    color: #2d7bbc;
  }

  #back {
    width: 2rem;
    height: 2rem;

    cursor: pointer;

    position: absolute;

    left: 1rem;
  }

  //
  //
  //                                  Inicio do form
  //
  //

  form {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;

    align-items: center;

    overflow: auto;

    padding: 2rem 5rem;
  }

  .input-wrapper {
    display: flex;
    flex-direction: column;

    width: 100%;

    font-weight: bold;

    justify-content: center;

    gap: 1rem;
  }

  .wrapper {
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 3rem;
  }

  input {
    width: 100%;
    height: 3rem;

    font-size: 1.2rem;

    padding: 1rem;

    border: solid 1px #c0c4df;
    border-radius: 0.25rem;

    ::placeholder {
      font-size: 1rem;
      font-family: "Mulish";
      font-weight: 400;

      color: #c0c4df;

      vertical-align: middle;
    }
  }

  .input-error {
    border: solid 1px red;

    ::placeholder {
      color: red;
    }
  }

  .select-content {
    display: flex;

    width: 100%;
    height: 4rem;

    gap: 1rem;
    padding: 0 0 0 1rem;

    background-color: #2d7bbc;

    border-radius: 0.5rem 1rem 1rem 0.5rem;

    align-items: center;

    color: white;

    p {
      font-weight: 700;
    }
  }

  .select-wrapper {
    display: flex;

    width: 85%;
    height: 25%;

    justify-content: center;
    align-items: center;
  }

  .btn-container {
    display: flex;

    width: 100%;

    height: 25%;

    margin-top: 1rem;

    justify-content: space-between;
    align-items: center;
  }

  .btn-style {
    width: 10rem;
    height: 3rem;

    border-radius: 0.25rem;

    font-size: 1.25rem;

    text-transform: uppercase;

    cursor: pointer;
  }

  #cancel-button {
    border: 1px solid #2d7bbc;

    background-color: white;

    color: #2d7bbc;
  }

  #submit-button {
    background-color: #2d7bbc;

    border: none;

    color: white;
  }

  .error-wrapper {
    display: flex;

    width: 100%;
    height: 2rem;

    align-items: center;

    svg {
      width: 10%;
      height: 75%;
    }
  }
`;
